import {
  Box,
  Button,
  FormHelperText,
  OutlinedInput,
  styled,
} from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const MainContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

export const OverallError = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.lighter,
  borderRadius: '8px',
  padding: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

export const LoginFormInput = styled(OutlinedInput)(({ theme }) => ({
  '&.Mui-error': {
    borderColor: theme.palette.error.main,
  },
}));

export const LoginFormHelperText = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.error.main,
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
}));

export const ActionContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const ForgetPasswordText = styled('a')(({ theme }) => ({
  all: 'unset',
  fontSize: pxToRem(12),
  color: `${theme.palette.grey[600]}`,
  cursor: 'pointer',
  textDecorationLine: 'underline',
  textDecorationThickness: '1px',
  textUnderlineOffset: '4px',
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  height: '51px',
  [theme.breakpoints.down('tablet')]: {
    height: '43px',
  },
}));
